import axios from "axios";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "react-query";
import { IHeadersProps, userInfoProps } from "../recoil/userInfoAtom";

// 게시글 쓰기
interface IPostProps {
  postApi: string;
  postValue: any;
  headers: IHeadersProps;
}

const postData = async (props: IPostProps) => {
  const { postApi, postValue, headers } = props;
  let res = await axios.post(postApi, postValue, {
    headers: { ...headers, "Content-Type": "multipart/form-data" }
  });

  return res;
};

export const usePostContentsMutation = (type: string, alertText: string) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  return useMutation(postData, {
    onSuccess: (api) => {
      if (api.data.result === 1) {
        queryClient.invalidateQueries([type]);
        alert(t(alertText));
        window.scrollTo(0, 0);
      }
    },
    onError: (error) => {
      // console.log(error, "Post Mutation error");
    }
  });
};

// 이전  내용 보기
interface getBeforeProps {
  getApi: string;
  headers: IHeadersProps;
}

export const getBeforeContent = async (props: getBeforeProps) => {
  const { getApi, headers } = props;
  const { data } = await axios.get(getApi, { headers: { ...headers } });
  return data;
};

// 수정 내용 저장하기
interface IPutProps {
  putApi: string;
  postValue: any;
  headers: IHeadersProps;
}

const putData = async (props: IPutProps) => {
  const { putApi, headers, postValue } = props;
  const res = await axios.post(putApi, postValue, {
    headers: { ...headers, "Content-Type": "multipart/form-data" }
  });

  return res;
};

export const usePutContentsMutation = (type: string, alertText: string) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  return useMutation(putData, {
    onSuccess: (api) => {
      if (api.data.result === 1) {
        queryClient.invalidateQueries([type]);
        alert(t(alertText));
      } else {
        alert(t(api?.data.msg));
      }
    },
    onError: (error) => {
      // console.log(error, "Put Mutation error");
    }
  });
};
